import { HttpClient } from "./HttpClient";

export const GetPaginatedList = async ({
  searchString,
  isRead,
  sortColumn = "dateCreated",
  sortOrder = "desc",
  pageNumber = 1,
  rowsPerPage = 10,
}) => {
  try {
    const { data } = await HttpClient.get("api/TransactionNotification", {
      params: {
        pageNumber,
        rowsPerPage,
        sortOrder,
        ...(sortColumn && { sortColumn }),
        ...(searchString && { searchString }),
        ...(isRead !== undefined && { isRead }),
      },
    });
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const MarkAsRead = async (notificationId) => {
  try {
    const response = await HttpClient.put(`api/TransactionNotification/mark-as-read/${notificationId}`);
    return response;
  } catch (error) {
    console.error("Error marking notification as read:", error);
    return {
      success: false,
      message:
        error.response?.data?.detail || "Failed to mark notification as read.",
    };
  }
};

export const MarkAllAsRead = async () => {
  try {
    const response = await HttpClient.put("api/TransactionNotification/mark-all-as-read");
    return response;
  } catch (error) {
    console.error("Error marking notification as read:", error);
    return {
      success: false,
      message:
        error.response?.data?.detail || "Failed to mark notification as read.",
    };
  }
};
